import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { subGroupClubGalleryQueries } from '@/services/groupsManagement/subGroupClubGallery.queries';
import { useSearch } from '@tanstack/react-router';

export const useClubGalleryList = () => {
  const { sort } = useSearch({ from: '/(app)/configuration-management/group-management/$sub-group/$club-gallery' });

  const { data, isFetched } = useQuery({
    ...subGroupClubGalleryQueries.list(),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, sort),
    }),
  });
  return {
    clubGalleryList: data?.data || [],
    isFetched,
  };
};
